module.exports = __webpack_public_path__ + "static/media/Photo8.cd05c963.jpg";